import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.array.sort.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as nls from '../../../nls.js';
import { onUnexpectedError } from '../../../base/common/errors.js';
import { Selection } from '../core/selection.js';
import { URI } from '../../../base/common/uri.js';
import { TextChange, compressConsecutiveTextChanges } from './textChange.js';
import * as buffer from '../../../base/common/buffer.js';

function uriGetComparisonKey(resource) {
  return resource.toString();
}

var SingleModelEditStackData = /*#__PURE__*/function () {
  function SingleModelEditStackData(beforeVersionId, afterVersionId, beforeEOL, afterEOL, beforeCursorState, afterCursorState, changes) {
    _classCallCheck(this, SingleModelEditStackData);

    this.beforeVersionId = beforeVersionId;
    this.afterVersionId = afterVersionId;
    this.beforeEOL = beforeEOL;
    this.afterEOL = afterEOL;
    this.beforeCursorState = beforeCursorState;
    this.afterCursorState = afterCursorState;
    this.changes = changes;
  }

  _createClass(SingleModelEditStackData, [{
    key: "append",
    value: function append(model, textChanges, afterEOL, afterVersionId, afterCursorState) {
      if (textChanges.length > 0) {
        this.changes = compressConsecutiveTextChanges(this.changes, textChanges);
      }

      this.afterEOL = afterEOL;
      this.afterVersionId = afterVersionId;
      this.afterCursorState = afterCursorState;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var necessarySize = +4 // beforeVersionId
      + 4 // afterVersionId
      + 1 // beforeEOL
      + 1 // afterEOL
      + SingleModelEditStackData._writeSelectionsSize(this.beforeCursorState) + SingleModelEditStackData._writeSelectionsSize(this.afterCursorState) + 4 // change count
      ;

      var _iterator = _createForOfIteratorHelper(this.changes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var change = _step.value;
          necessarySize += change.writeSize();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var b = new Uint8Array(necessarySize);
      var offset = 0;
      buffer.writeUInt32BE(b, this.beforeVersionId, offset);
      offset += 4;
      buffer.writeUInt32BE(b, this.afterVersionId, offset);
      offset += 4;
      buffer.writeUInt8(b, this.beforeEOL, offset);
      offset += 1;
      buffer.writeUInt8(b, this.afterEOL, offset);
      offset += 1;
      offset = SingleModelEditStackData._writeSelections(b, this.beforeCursorState, offset);
      offset = SingleModelEditStackData._writeSelections(b, this.afterCursorState, offset);
      buffer.writeUInt32BE(b, this.changes.length, offset);
      offset += 4;

      var _iterator2 = _createForOfIteratorHelper(this.changes),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _change = _step2.value;
          offset = _change.write(b, offset);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return b.buffer;
    }
  }], [{
    key: "create",
    value: function create(model, beforeCursorState) {
      var alternativeVersionId = model.getAlternativeVersionId();
      var eol = getModelEOL(model);
      return new SingleModelEditStackData(alternativeVersionId, alternativeVersionId, eol, eol, beforeCursorState, beforeCursorState, []);
    }
  }, {
    key: "_writeSelectionsSize",
    value: function _writeSelectionsSize(selections) {
      return 4 + 4 * 4 * (selections ? selections.length : 0);
    }
  }, {
    key: "_writeSelections",
    value: function _writeSelections(b, selections, offset) {
      buffer.writeUInt32BE(b, selections ? selections.length : 0, offset);
      offset += 4;

      if (selections) {
        var _iterator3 = _createForOfIteratorHelper(selections),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var selection = _step3.value;
            buffer.writeUInt32BE(b, selection.selectionStartLineNumber, offset);
            offset += 4;
            buffer.writeUInt32BE(b, selection.selectionStartColumn, offset);
            offset += 4;
            buffer.writeUInt32BE(b, selection.positionLineNumber, offset);
            offset += 4;
            buffer.writeUInt32BE(b, selection.positionColumn, offset);
            offset += 4;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      return offset;
    }
  }, {
    key: "_readSelections",
    value: function _readSelections(b, offset, dest) {
      var count = buffer.readUInt32BE(b, offset);
      offset += 4;

      for (var i = 0; i < count; i++) {
        var selectionStartLineNumber = buffer.readUInt32BE(b, offset);
        offset += 4;
        var selectionStartColumn = buffer.readUInt32BE(b, offset);
        offset += 4;
        var positionLineNumber = buffer.readUInt32BE(b, offset);
        offset += 4;
        var positionColumn = buffer.readUInt32BE(b, offset);
        offset += 4;
        dest.push(new Selection(selectionStartLineNumber, selectionStartColumn, positionLineNumber, positionColumn));
      }

      return offset;
    }
  }, {
    key: "deserialize",
    value: function deserialize(source) {
      var b = new Uint8Array(source);
      var offset = 0;
      var beforeVersionId = buffer.readUInt32BE(b, offset);
      offset += 4;
      var afterVersionId = buffer.readUInt32BE(b, offset);
      offset += 4;
      var beforeEOL = buffer.readUInt8(b, offset);
      offset += 1;
      var afterEOL = buffer.readUInt8(b, offset);
      offset += 1;
      var beforeCursorState = [];
      offset = SingleModelEditStackData._readSelections(b, offset, beforeCursorState);
      var afterCursorState = [];
      offset = SingleModelEditStackData._readSelections(b, offset, afterCursorState);
      var changeCount = buffer.readUInt32BE(b, offset);
      offset += 4;
      var changes = [];

      for (var i = 0; i < changeCount; i++) {
        offset = TextChange.read(b, offset, changes);
      }

      return new SingleModelEditStackData(beforeVersionId, afterVersionId, beforeEOL, afterEOL, beforeCursorState, afterCursorState, changes);
    }
  }]);

  return SingleModelEditStackData;
}();

export var SingleModelEditStackElement = /*#__PURE__*/function () {
  function SingleModelEditStackElement(model, beforeCursorState) {
    _classCallCheck(this, SingleModelEditStackElement);

    this.model = model;
    this._data = SingleModelEditStackData.create(model, beforeCursorState);
  }

  _createClass(SingleModelEditStackElement, [{
    key: "type",
    get: function get() {
      return 0
      /* Resource */
      ;
    }
  }, {
    key: "resource",
    get: function get() {
      if (URI.isUri(this.model)) {
        return this.model;
      }

      return this.model.uri;
    }
  }, {
    key: "label",
    get: function get() {
      return nls.localize('edit', "Typing");
    }
  }, {
    key: "toString",
    value: function toString() {
      var data = this._data instanceof SingleModelEditStackData ? this._data : SingleModelEditStackData.deserialize(this._data);
      return data.changes.map(function (change) {
        return change.toString();
      }).join(', ');
    }
  }, {
    key: "matchesResource",
    value: function matchesResource(resource) {
      var uri = URI.isUri(this.model) ? this.model : this.model.uri;
      return uri.toString() === resource.toString();
    }
  }, {
    key: "setModel",
    value: function setModel(model) {
      this.model = model;
    }
  }, {
    key: "canAppend",
    value: function canAppend(model) {
      return this.model === model && this._data instanceof SingleModelEditStackData;
    }
  }, {
    key: "append",
    value: function append(model, textChanges, afterEOL, afterVersionId, afterCursorState) {
      if (this._data instanceof SingleModelEditStackData) {
        this._data.append(model, textChanges, afterEOL, afterVersionId, afterCursorState);
      }
    }
  }, {
    key: "close",
    value: function close() {
      if (this._data instanceof SingleModelEditStackData) {
        this._data = this._data.serialize();
      }
    }
  }, {
    key: "undo",
    value: function undo() {
      if (URI.isUri(this.model)) {
        // don't have a model
        throw new Error("Invalid SingleModelEditStackElement");
      }

      if (this._data instanceof SingleModelEditStackData) {
        this._data = this._data.serialize();
      }

      var data = SingleModelEditStackData.deserialize(this._data);

      this.model._applyUndo(data.changes, data.beforeEOL, data.beforeVersionId, data.beforeCursorState);
    }
  }, {
    key: "redo",
    value: function redo() {
      if (URI.isUri(this.model)) {
        // don't have a model
        throw new Error("Invalid SingleModelEditStackElement");
      }

      if (this._data instanceof SingleModelEditStackData) {
        this._data = this._data.serialize();
      }

      var data = SingleModelEditStackData.deserialize(this._data);

      this.model._applyRedo(data.changes, data.afterEOL, data.afterVersionId, data.afterCursorState);
    }
  }]);

  return SingleModelEditStackElement;
}();
export var MultiModelEditStackElement = /*#__PURE__*/function () {
  function MultiModelEditStackElement(label, editStackElements) {
    _classCallCheck(this, MultiModelEditStackElement);

    this.type = 1
    /* Workspace */
    ;
    this.label = label;
    this._isOpen = true;
    this._editStackElementsArr = editStackElements.slice(0);
    this._editStackElementsMap = new Map();

    var _iterator4 = _createForOfIteratorHelper(this._editStackElementsArr),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var editStackElement = _step4.value;
        var key = uriGetComparisonKey(editStackElement.resource);

        this._editStackElementsMap.set(key, editStackElement);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    this._delegate = null;
  }

  _createClass(MultiModelEditStackElement, [{
    key: "resources",
    get: function get() {
      return this._editStackElementsArr.map(function (editStackElement) {
        return editStackElement.resource;
      });
    }
  }, {
    key: "prepareUndoRedo",
    value: function prepareUndoRedo() {
      if (this._delegate) {
        return this._delegate.prepareUndoRedo(this);
      }
    }
  }, {
    key: "matchesResource",
    value: function matchesResource(resource) {
      var key = uriGetComparisonKey(resource);
      return this._editStackElementsMap.has(key);
    }
  }, {
    key: "setModel",
    value: function setModel(model) {
      var key = uriGetComparisonKey(URI.isUri(model) ? model : model.uri);

      if (this._editStackElementsMap.has(key)) {
        this._editStackElementsMap.get(key).setModel(model);
      }
    }
  }, {
    key: "canAppend",
    value: function canAppend(model) {
      if (!this._isOpen) {
        return false;
      }

      var key = uriGetComparisonKey(model.uri);

      if (this._editStackElementsMap.has(key)) {
        var editStackElement = this._editStackElementsMap.get(key);

        return editStackElement.canAppend(model);
      }

      return false;
    }
  }, {
    key: "append",
    value: function append(model, textChanges, afterEOL, afterVersionId, afterCursorState) {
      var key = uriGetComparisonKey(model.uri);

      var editStackElement = this._editStackElementsMap.get(key);

      editStackElement.append(model, textChanges, afterEOL, afterVersionId, afterCursorState);
    }
  }, {
    key: "close",
    value: function close() {
      this._isOpen = false;
    }
  }, {
    key: "undo",
    value: function undo() {
      this._isOpen = false;

      var _iterator5 = _createForOfIteratorHelper(this._editStackElementsArr),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var editStackElement = _step5.value;
          editStackElement.undo();
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "redo",
    value: function redo() {
      var _iterator6 = _createForOfIteratorHelper(this._editStackElementsArr),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var editStackElement = _step6.value;
          editStackElement.redo();
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "split",
    value: function split() {
      return this._editStackElementsArr;
    }
  }]);

  return MultiModelEditStackElement;
}();

function getModelEOL(model) {
  var eol = model.getEOL();

  if (eol === '\n') {
    return 0
    /* LF */
    ;
  } else {
    return 1
    /* CRLF */
    ;
  }
}

export function isEditStackElement(element) {
  if (!element) {
    return false;
  }

  return element instanceof SingleModelEditStackElement || element instanceof MultiModelEditStackElement;
}
export var EditStack = /*#__PURE__*/function () {
  function EditStack(model, undoRedoService) {
    _classCallCheck(this, EditStack);

    this._model = model;
    this._undoRedoService = undoRedoService;
  }

  _createClass(EditStack, [{
    key: "pushStackElement",
    value: function pushStackElement() {
      var lastElement = this._undoRedoService.getLastElement(this._model.uri);

      if (isEditStackElement(lastElement)) {
        lastElement.close();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this._undoRedoService.removeElements(this._model.uri);
    }
  }, {
    key: "_getOrCreateEditStackElement",
    value: function _getOrCreateEditStackElement(beforeCursorState) {
      var lastElement = this._undoRedoService.getLastElement(this._model.uri);

      if (isEditStackElement(lastElement) && lastElement.canAppend(this._model)) {
        return lastElement;
      }

      var newElement = new SingleModelEditStackElement(this._model, beforeCursorState);

      this._undoRedoService.pushElement(newElement);

      return newElement;
    }
  }, {
    key: "pushEOL",
    value: function pushEOL(eol) {
      var editStackElement = this._getOrCreateEditStackElement(null);

      this._model.setEOL(eol);

      editStackElement.append(this._model, [], getModelEOL(this._model), this._model.getAlternativeVersionId(), null);
    }
  }, {
    key: "pushEditOperation",
    value: function pushEditOperation(beforeCursorState, editOperations, cursorStateComputer) {
      var editStackElement = this._getOrCreateEditStackElement(beforeCursorState);

      var inverseEditOperations = this._model.applyEdits(editOperations, true);

      var afterCursorState = EditStack._computeCursorState(cursorStateComputer, inverseEditOperations);

      var textChanges = inverseEditOperations.map(function (op, index) {
        return {
          index: index,
          textChange: op.textChange
        };
      });
      textChanges.sort(function (a, b) {
        if (a.textChange.oldPosition === b.textChange.oldPosition) {
          return a.index - b.index;
        }

        return a.textChange.oldPosition - b.textChange.oldPosition;
      });
      editStackElement.append(this._model, textChanges.map(function (op) {
        return op.textChange;
      }), getModelEOL(this._model), this._model.getAlternativeVersionId(), afterCursorState);
      return afterCursorState;
    }
  }], [{
    key: "_computeCursorState",
    value: function _computeCursorState(cursorStateComputer, inverseEditOperations) {
      try {
        return cursorStateComputer ? cursorStateComputer(inverseEditOperations) : null;
      } catch (e) {
        onUnexpectedError(e);
        return null;
      }
    }
  }]);

  return EditStack;
}();